module.exports = __webpack_public_path__ + "static/media/life-insurance_new.b2740da2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/life-insurance_new.svg
// module id = 3201
// module chunks = 0